





import Vue from 'vue';
// @ts-ignore
import Item from '@/old/api/item/item';
// @ts-ignore
import ItemIcon from '@/old/game/ItemIcon';

export default Vue.extend({
    name: 'ItemRef',
    components: {
        ItemIcon,
    },
    props: {
        itemId: {
            type: Number as () => number,
            required: true,
        },
    },
    data() {
        return {
            itemName: '',
            itemData: null as any,
        };
    },
    watch: {
        itemId() {
            this.load();
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.itemName = '';
            this.itemData = null;
            Item.getItem(this.itemId, this.$store.state.regionCode,
                (res: any) => {
                    this.itemData = res;
                    this.itemName = this._deriveName(res);
                },
                () => {
                    // keep "Item {id}" fallback
                });
        },
        _deriveName(itemData: any): string {
            if (itemData.name) {
                if (itemData.name.name && itemData.name._NameID) {
                    return itemData.name.name;
                } else if (itemData.name._NameID) {
                    return 'Item MID: ' + itemData.name._NameID;
                }
            }

            return 'Unnamed Item ' + this.itemId;
        },
    },
});
